import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { NfcCard } from "@/components/landing/NfcCard";
import { Footer } from "@/components/landing/Footer";

export default function NfcCardPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-bone" data-testid="nfc-card-page">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 pt-28 md:pt-32">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-ink/60 hover:text-coral transition-colors"
          data-testid="nfc-page-back"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Chateaux
        </Link>
      </div>
      <NfcCard />
      <Footer />
    </div>
  );
}
